import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { useTranslation } from '@/app/i18n/client'
import Image from 'next/image'
import React from 'react'

const ProductOrServiceSection = ({
  products,
  type,
}: {
  products: { name: string; varieties: string[] }[]
  type: string
}) => {
  const { t } = useTranslation()
  return (
    <div className="w-[952px] shadow-[0_0_6px_0_rgba(0,0,0,0.16)] rounded mt-8 mb-14 mobile-width">
      <h2 className="text-base font-ns_bold border-b border-solid border-input p-6 py-5">
        {type === 'Products' ? t('Our Products') : t('All Services')}
      </h2>
      {products?.length > 0 ? (
        <div className="grid grid-cols-2 p-6 py-5">
          {products?.map(
            (item: { name: string; varieties: string[] }, index: number) => (
              <CustomErrorBoundary key={`-${index}-`}>
                <div className="text-base font-ns_semibold py-2">
                  <p className="text-text_dark">{item?.name}</p>
                  <p className="text-grey_forty">
                    {item?.varieties?.length > 0 &&
                      String(item?.varieties?.join(', '))}
                  </p>
                </div>
              </CustomErrorBoundary>
            )
          )}
        </div>
      ) : (
        <div className="p-16 flex flex-col gap-2 items-center justify-center text-primary-foreground">
          <Image
            loading="lazy"
            width={86}
            height={94}
            src="/assets/Icons/noImage/noProductIcon.svg"
            alt=""
            className="w-[85px] h-[94px] object-cover" 
          />
          <div className="flex">{t('Product & service not available')}</div>
        </div>
      )}
    </div>
  )
}

export default ProductOrServiceSection
